
import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import { NavItem } from './types';
import { useMobileNavigationItemHandlers } from './useMobileNavigationItemHandlers';

interface MobileNavigationDropdownItemProps {
  item: NavItem;
  isActive: (href: string) => boolean;
  expanded: { [key: string]: boolean };
  onToggleExpand: (label: string) => void;
  onClose: () => void;
  onNavigationClick?: (href: string) => void;
}

export const MobileNavigationDropdownItem: React.FC<MobileNavigationDropdownItemProps> = ({
  item,
  isActive,
  expanded,
  onToggleExpand,
  onClose,
  onNavigationClick
}) => {
  const { handleClick } = useMobileNavigationItemHandlers({
    onNavigationClick,
    onClose
  });

  return (
    <div>
      <button
        className={`flex items-center justify-between w-full text-gray-700 px-2 py-3 text-lg font-semibold transition-colors ${
          expanded[item.label] ? 'bg-blue-50' : 'hover:text-blue-600 hover:bg-gray-100'
        }`}
        onClick={() => onToggleExpand(item.label)}
        aria-expanded={expanded[item.label] || false}
        style={{ minHeight: 44, minWidth: 44 }}
      >
        <span>{item.label}</span>
        <ChevronDown
          className={`ml-1 h-5 w-5 transition-transform duration-150 ${expanded[item.label] ? 'rotate-180' : ''}`}
          aria-hidden="true"
        />
      </button>
      {expanded[item.label] && (
        <div className="pl-4 space-y-1">
          {item.dropdownItems?.map((dropdownItem) => (
            <Link
              key={dropdownItem.href}
              to={dropdownItem.href}
              onClick={(e) => handleClick(dropdownItem.href, e)}
              className={`block px-2 py-3 rounded-md text-base font-medium transition-colors ${
                isActive(dropdownItem.href)
                  ? 'text-blue-600 bg-blue-50'
                  : 'text-gray-700 hover:text-blue-600 hover:bg-gray-100'
              }`}
              style={{ minHeight: 44, minWidth: 44 }}
              role="menuitem"
              tabIndex={0}
              aria-current={isActive(dropdownItem.href) ? "page" : undefined}
            >
              {dropdownItem.label}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};
